var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['tag',_vm.type,_vm.size],on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"tag_txt"},[(_vm.title)?_c('div',{staticClass:"hide"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2),(_vm.icon)?_c('div',{staticClass:"icon"},[_c('GI',{attrs:{"name":_vm.icon,"ws":"20","hs":"20"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }